<template>
    <div class="carousel-pp">
        <div
            id="carouselExampleControls"
            class="carousel slide"
            data-ride="carousel"
        >
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div
                        class="bg-img"
                        v-bind:style="{
                            backgroundImage:
                                'url(' +
                                require('@/assets/carousel-1.jpg') +
                                ')',
                            height: '676px'
                        }"
                    ></div>
                    <div class="carousel-caption d-none d-md-block">
                        <h1 class="title">
                            Plataforma Potências Periféricas.
                        </h1>
                        <div class="content">
                            Somos uma plataforma para facilitar o 'matching', ou seja, o encontro e a conexão entre doadores e donatários!
                        </div>
                        <div class="footer-buttons">
                            <button type="button" class="btn btn-aux-blue">
                                Ver mapa de potências e organizações
                            </button>
                        </div>
                    </div>
                </div>

                <div class="carousel-item">
                    <div
                        class="bg-img"
                        v-bind:style="{
                            backgroundImage:
                                'url(' +
                                require('@/assets/carousel-2.jpg') +
                                ')',
                            height: '676px'
                        }"
                    ></div>
                    <div class="carousel-caption d-none d-md-block">
                        <h1 class="title">
                            Plataforma Potências Periféricas.
                        </h1>
                        <div class="content">
                            Somos uma plataforma para facilitar o 'matching', ou seja, o encontro e a conexão entre doadores e donatários!
                        </div>
                        <div class="footer-buttons">
                            <button type="button" class="btn btn-aux-blue">
                                Ver mapa de potências e organizações
                            </button>
                        </div>
                    </div>
                </div>

                <div class="carousel-item">
                    <div
                        class="bg-img"
                        v-bind:style="{
                            backgroundImage:
                                'url(' +
                                require('@/assets/carousel-3.jpg') +
                                ')',
                            height: '676px'
                        }"
                    ></div>
                    <div class="carousel-caption d-none d-md-block">
                        <h1 class="title">
                            Plataforma Potências Periféricas.
                        </h1>
                        <div class="content">
                            Somos uma plataforma para facilitar o 'matching', ou seja, o encontro e a conexão entre doadores e donatários!
                        </div>
                        <div class="footer-buttons">
                            <button type="button" class="btn btn-aux-blue">
                                Ver mapa de potências e organizações
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <a
                class="carousel-control-prev"
                href="#carouselExampleControls"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                href="#carouselExampleControls"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CarouselPP'
}
</script>

<style scope src="./CarouselPP.css"></style>



// WEBPACK FOOTER //
// src/ui/carousel-pp/CarouselPP.vue